import React, { Component } from 'react';
import { Button } from 'antd';

/**
 * value由只能由props中传入，为了校验数量是否有权限加减不自己在state中维护
 * pc或触屏 纯步进器
*/

export default class StepperSelf extends Component {
  constructor(props) {
    super(props)
    let calcMin = props.min !== undefined ? props.min : 1;
    let obj = {
      showType: props.showType || 'text', /*数字展示区域类型 'text' || 'input'*/
      min: calcMin,
      max: props.max !== undefined ? props.max : 9999999,
      value: props.value!==undefined ? props.value : calcMin,
      step: props.step || 1,
      isMin: false,       /*是否达到最小值*/
      isMax: false,
      disabled: props.disabled, /* 加减号是否显示 */
      decimal: props.decimal || 0
    }
    if (obj.min == obj.value) obj.isMin = true
    if (obj.max == obj.value) obj.isMax = true
    this.state = obj
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value != this.state.value || nextProps.disabled != this.state.disabled) {
      this.setState({ value: nextProps.value, disabled: nextProps.disabled })
    }
    if (nextProps.showType != this.state.showType && nextProps.showType !== undefined) {
      this.setState({ showType: nextProps.showType })
    }
  }

  downClick(e) {
    let { value, min, step } = this.state;
    value = Number(value) - step;
    if (value <= min) {
      this.setState({ isMin: true, isMax: false });
      value = min
    } else {
      this.setState({ isMin: false, isMax: false });
    }
    if (this.props.onChange)
      this.props.onChange(value, e, 'down')
  }

  upClick(e) {
    let { value, step, max } = this.state;
    if(value === undefined) value = 0;
    value = Number(value) + step;
    if (value >= max) {
      value = max
      this.setState({ isMax: true, isMin: true })
    } else {
      this.setState({ isMax: false, isMin: false })
    }
    if (this.props.onChange)
      this.props.onChange(value, e, 'up')
  }
  onValueChange = (e) => {
    let val = e.target.value;
    if (isNaN(val)) {
      cb.utils.alert('录入不合法~', 'error');
      return
    }
    this.setState({value: val}) 
  }

  onBlur = (e) => {
    this.setState({focusIng: false})
    let val = e.target.value
    if (this.props.onChange)
      this.props.onChange(val)
  }

  onFocus = () => {
    this.setState({focusIng: true})
  }

  inputDivClick = () => {
    if (this.props.onNumberClick)
      this.props.onNumberClick()
  }

  format(value){
    if (value === '') return ''
    let { min, decimal, focusIng } = this.state;
    value = Number(value);
    if(isNaN(value)) {
      if (focusIng)
        return Number(Number(min).toFixed(decimal))
      else
        return Number(min).toFixed(decimal)
    } else {
      if (focusIng)
        return Number(value.toFixed(decimal))
      else 
        return value.toFixed(decimal)
    }
  }
  render() {
    let { showType, value, isMin, isMax, disabled, min, max, decimal } = this.state;
    if (value == min && !isMin) isMin = true
    if (value != min && isMin) isMin = false
    if (value == max && !isMax) isMax = true
    if (value != max && isMax) isMax = false
    return (
      <div className="billing-input-number">
                {disabled ? null :<div className={isMin ? "billing-disable-button billing-input-left-button" : "billing-input-left-button"}><Button icon="minus" onClick={(e) => this.downClick(e)} /></div>}
                {/* <InputNumber ref="input" value={parseFloat(this.state.value).toFixed(precisionNum)} disabled={this.state.disabled}
                    onChange={this.onValueChange} onClick={this.onClick} onBlur={this.onBlur} onFocus={this.onFocus} /> */}
                <div className="ant-input-number">
                    <div className="ant-input-number-handler-wrap">
                        <span unselectable="unselectable" role="button" aria-label="Increase Value" aria-disabled="false" className="ant-input-number-handler ant-input-number-handler-up ">
                            <span unselectable="unselectable" className="ant-input-number-handler-up-inner"></span>
                        </span>
                        <span unselectable="unselectable" role="button" aria-label="Decrease Value" aria-disabled="false" className="ant-input-number-handler ant-input-number-handler-down ">
                            <span unselectable="unselectable" className="ant-input-number-handler-down-inner">
                            </span>
                        </span>
                    </div>
                    <div className="ant-input-number-input-wrap" role="spinbutton" aria-valuemin="-9007199254740991" aria-valuemax="9007199254740991" aria-valuenow="1">
                        {/* <input step="1" min="-9007199254740991" max="9007199254740991" className="ant-input-number-input" autocomplete="off" value="1"> */}
                        {showType === 'text' ? <div className="ant-input-number-input" onClick={this.inputDivClick}>{this.format(value)}</div> :
                          <input className="ant-input-number-input" value={this.format(value)} onChange={this.onValueChange} onBlur={this.onBlur} onFocus={this.onFocus} />}
                    </div>
                </div>
                {disabled ? null : <div className={isMax ? 'billing-disable-button billing-input-right-button': 'billing-input-right-button'}><Button icon="plus" onClick={(e) => this.upClick(e)} /> </div>}
            </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/common/StepperCommon.jsx